import type { ReactElement } from 'react'

import { IR_FINANCIAL_ROUTE } from '@/utils/routes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'

export const FinancialPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Financial Information"
        subTitleText="業績・財務情報"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <LinkCardList>
        {IR_FINANCIAL_ROUTE.subdirectories.map(
          ({ path, name, imagePath, ...rest }) => (
            <LinkCard
              link={path}
              title={name}
              imgPath={imagePath}
              forceReload={path === '/ir/financial/chart/'}
              {...rest}
              key={path}
            />
          )
        )}
      </LinkCardList>
    </Layout>
  )
}

FinancialPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '業績・財務情報', path: '' },
  ]

  return (
    <>
      <Head
        title="業績・財務情報"
        description="トライアルホールディングスの業績と財務情報について掲載しています。"
        ogp={{ url: 'ir/financial' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
